import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import Loader from "../Common/Loader";
import {
  createAnupanAction,
  updateAnupanAction,
} from "../../../store/actions/AnupanAction";

const AddAnupan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { item } = location.state || {};
  const isEditMode = !!item;

  const [anupanaText, setAnupanaText] = useState("");
  const [status, setStatus] = useState("Active");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  useEffect(() => {
    if (item) {
      setAnupanaText(item.anupana_text || "");
      setStatus(item.anupana_status || "Active");
    }
  }, [item]);

  const validateForm = () => {
    const err = {};
    if (!anupanaText.trim()) err.anupanaText = "Anupan is required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const { [field]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleFieldChange = (field, value) => {
    if (field === "anupanaText") setAnupanaText(value);
    else if (field === "status") setStatus(value);
    clearFieldError(field);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const payload = {
      anupana_text: anupanaText,
      anupana_status: status,
    };

    try {
      if (isEditMode) {
        await dispatch(updateAnupanAction(payload, item.id));
      } else {
        await dispatch(createAnupanAction(payload));
      }
      navigate("/app-anupan");
    } catch (err) {
      console.error("Save failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end mb-3">
          <Link to="/app-anupan">
            <Button variant="primary">Back</Button>
          </Link>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">
                  Anupan <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={anupanaText}
                  style={{ padding: "0.375rem 0.75rem", paddingTop: "0.6rem" }}
                  onChange={(e) => handleFieldChange("anupanaText", e.target.value)}
                />
                {errors.anupanaText && (<small className="text-danger">{errors.anupanaText}</small>)}
              </div>

              <div className="mb-3">
                <label className="form-label">Status</label>
                <Select
                  options={statusOptions}
                  value={statusOptions.find((opt) => opt.value === status)}
                  onChange={(selectedOption) => setStatus(selectedOption ? selectedOption.value : "")}
                  placeholder="Select Status"
                  isClearable
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: "50px",
                      height: "50px",
                    }),
                    singleValue: (provided) => ({ ...provided, lineHeight: "50px" }),
                    dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                />
              </div>

              <button className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">{isEditMode ? "Updating..." : "Saving..."}</span>
                  </>
                ) : isEditMode ? (
                  "Update Anupan"
                ) : (
                  "Add Anupan"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAnupan;
